// features/removals/removalsAPI.js

// Helper to get user from localStorage
const getUser = () => {
  try {
    const user = localStorage.getItem('admin_user');
    return user ? JSON.parse(user) : null;
  } catch (e) {
    return null;
  }
};

// ==================== REMOVALS APIs ====================

// Fetch All Removals (Admin/Superadmin)
export const fetchRemovalsAPI = async () => {
  try {
    const response = await fetch("https://alcobrakeadmin.com/v3/us/fullclients/getallremovals");
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data || [];
  } catch (error) {
    console.error("Error fetching removals:", error);
    throw error;
  }
};

// Fetch Dealer Removals
export const fetchDealerRemovalsAPI = async (dealerId) => {
  try {
    const response = await fetch(`https://alcobrakeadmin.com/v3/us/fullclients/getdealerremovals?dealerName=${encodeURIComponent(dealerId)}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data || [];
  } catch (error) {
    console.error("Error fetching dealer removals:", error);
    throw error;
  }
};

// Restore Client from Removals
export const restoreClientAPI = async (clientId) => {
  try {
    // Step 1: Move from removals to clients
    const moveResponse = await fetch(`https://alcobrakeadmin.com/v3/us/fullclients/moveremoval/${clientId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    const moveResult = await moveResponse.text();
    console.log("Move response:", moveResult);
    
    if (moveResult !== "Success Moving to clients") {
      throw new Error("Failed to move to clients");
    }
    
    // Step 2: Delete from removals
    const deleteResponse = await fetch(`https://alcobrakeadmin.com/v3/us/fullclients/deleteremoval/${clientId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    });
    
    const deleteResult = await deleteResponse.text();
    console.log("Delete response:", deleteResult);
    
    if (deleteResult !== "delete success") {
      throw new Error("Failed to delete from removals");
    }
    
    return { success: true, message: "Successfully Restored to Clients" };
    
  } catch (error) {
    console.error("Error restoring client:", error);
    throw error;
  }
};

// Get Uninstallation Form PDF (CA Removals)
export const getUninstallationFormAPI = async (clientId) => {
  try {
    const response = await fetch(`https://alcobrakeadmin.com/v3/v2/reports/downloadcaremovalpdf?Id=${clientId}`, {
      method: 'GET',
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error("Error fetching uninstallation form:", error);
    throw error;
  }
};

// Get CSV Logs
export const getCSVLogsAPI = async (cbid, clientName) => {
  try {
    const response = await fetch(`https://alcobrakeadmin.com/v3/app/getImage/getcsvlog?file=${cbid}&client=${encodeURIComponent(clientName)}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const text = await response.text();
    return text;
  } catch (error) {
    console.error("Error fetching CSV logs:", error);
    throw error;
  }
};

// Get Text Logs
export const getTextLogsAPI = async (cbid, clientName) => {
  try {
    const response = await fetch(`https://alcobrakeadmin.com/v3/app/getImage/getcsvlog?file=${cbid}&client=${encodeURIComponent(clientName)}`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const text = await response.text();
    return text;
  } catch (error) {
    console.error("Error fetching text logs:", error);
    throw error;
  }
};
